var path = '/ui/grid/multiSelect/template/multiSelectButton.tpl.html';
var html = "<a ng-click=\"multiSelectUtil.onBeginMultiSelect()\"\n    class=\"bulkReassignButton\">\n    <span ui-translate>{{::multiSelectModel.multiSelectCogMenuLabel}}</span>\n</a>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;